<div class="center">
  <form [formGroup]="accessFeeFormGroup" class="flex-col width-800">
    <h2 class="center margin-y-10">
      Create AccessFee Rules
    </h2>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Plan Name:</label>
      <input formControlName="planName" name="planName" placeholder="Plan Name" class="flex-grow font-20 margin-l-10" />
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Services:</label>
      <ng-select formControlName="services" name="services" placeholder="Select services" (change)="validateModeAndGeoGroupIdForServices();"
        class="flex-grow font-20 margin-l-10" [multiple]="true" [hideSelected]="true" [compareWith]="compareServices">
        <ng-option *ngFor="let item of services" [value]="item">{{item.name}}</ng-option>
      </ng-select>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Zones:</label>
      <ng-select formControlName="zones" name="zones" placeholder="Select zones"
        class="flex-grow font-20 margin-l-10" [multiple]=true>
        <ng-option *ngFor="let item of zones" [value]="item">{{item.name}}</ng-option>
      </ng-select>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Target Segment:</label>
      <div class="flex-grow font-20 margin-l-10 target-segment">
        <label class="font-20">
          <input type="radio" name="targetSegment" [value]="'userSelectors'" formControlName="targetSegment">
          <span>User Selector</span>
        </label>
        <label class="font-20">
          <input type="radio" name="targetSegment" [value]="'entireCity'" formControlName="targetSegment">
          <span>Entire City (includes HH)</span>
        </label>
      </div>
    </div>


    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Plan Start Date:</label>
      <p-calendar formControlName="startDate" icon="pi pi-calendar" class="font-20 margin-l-10" name="startDate"
        [showIcon]=true dateFormat="dd-mm-yy" (ngModelChange)="changeInDate()" [minDate]="today" [defaultDate]="today"
        [maxDate]="maxStartDate" [selectOtherMonths]="true" [showButtonBar]="true">
      </p-calendar>
    </div>
    
    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Plan End Date:</label>
      <p-calendar formControlName="endDate" icon="pi pi-calendar" class="font-20 margin-l-10" name="endDate"
        [defaultDate]="tomorrowEod" [showIcon]=true dateFormat="dd-mm-yy" (ngModelChange)="changeInDate()"
        [selectOtherMonths]="true" [showButtonBar]="true" [minDate]="minEndDate">
      </p-calendar>
    </div>

    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">Plan Priority:</label>
      <input formControlName="priority" class="flex-grow font-20 margin-l-10 no-spinner" name="priority" type="number"
        min="0" (keydown)="blockInvalidNumberKeys($event)" (input)="rejectNegativeAmount($event, accessFeeFormGroup.get('priority'))"
        (wheel)="$event.preventDefault()" />
    </div>
    
    <div class="flex-row margin-y-10">
      <label class="width-50 font-20 bold">User Selector:</label>
      <ng-select formControlName="userSelector" name="userSelector" placeholder="Select User Selector" class="flex-grow font-20 margin-l-10" [multiple]=true>
        <ng-option *ngFor="let item of userSelectors" [value]="item">{{item.name}}</ng-option>
      </ng-select>
    </div>



    <div *ngFor="let tier of formValue('tiers') || []; let i = index">

      <label class="width-50 font-20 bold">Tier {{i+1}}:</label>

      <button mat-stroked-button (click)="deleteTier(i)" [disabled]="formValue('tiers').length === 1" color="warn"
      class="right-align">
      <mat-icon>delete</mat-icon>
      </button>

      <div class="margin-l-50">

        <div class="flex-row margin-y-10">
          <label class="width-50 font-20 bold">Condition for deduction</label>
          <ng-select [(ngModel)]="deductionCondition" [ngModelOptions]="{standalone: true}" [disabled]="true"
            name="condition" class="flex-grow font-20 margin-l-10">
            <ng-option value="Days">Days</ng-option>
          </ng-select>
        </div>

        <div class="flex-row margin-y-10">
          <label class="width-50 font-20 bold">Days Condition</label>
          <ng-select [(ngModel)]="daysCondition" [ngModelOptions]="{standalone: true}" [disabled]="true"
            name="daysCondition" class="flex-grow font-20 margin-l-10">
            <ng-option value="1">1</ng-option>
          </ng-select>
        </div>
        
        <div class="flex-row margin-y-10">
          <label class="width-50 font-20 bold">Minimum Rides</label>
          <input [formControl]="tier.minRides" class="flex-grow font-20 margin-l-10 no-spinner" name="minRides"
            type="number" min="0" (keydown)="blockInvalidNumberKeys($event)" (input)="rejectNegativeAmount($event, tier.minRides)"
            (wheel)="$event.preventDefault()" />
        </div>

        <div class="flex-row margin-y-10">
          <label class="width-50 font-20 bold">Charged Fee</label>
          <input [formControl]="tier.tierAmount" class="flex-grow font-20 margin-l-10 no-spinner" name="tierAmount"
            type="number" min="0" (keydown)="blockInvalidNumberKeys($event)" (input)="rejectNegativeAmount($event, tier.tierAmount)"
            (wheel)="$event.preventDefault()" />
        </div>

        <div class="flex-row margin-y-10">
          <label class="width-50 font-20 bold">Striked Out Amount</label>
          <input [formControl]="tier.strikeOutAmount" class="flex-grow font-20 margin-l-10 no-spinner" name="strikeOutAmount"
            type="number" min="0" (keydown)="blockInvalidNumberKeys($event)" (input)="rejectNegativeAmount($event, tier.strikeOutAmount)"
            (wheel)="$event.preventDefault()" />
        </div>
      </div>
    </div>

    <div class="margin-y-10 flex-row pull-right">
      <button mat-stroked-button (click)="addTier()">
        <mat-icon>add</mat-icon>
        Add Tier
      </button>
    </div>

    <div class="margin-y-10 flex-row pull-right">
      <button mat-raised-button class="btn-primary" (click)="createAccessFeeRules()"> Create Access Fee Rules </button>
    </div>
  </form>
</div>
<app-toaster [config]="toasterService.toaster"></app-toaster>

